/**
 * /compliance/* parent layout route.
 *
 * Wraps all compliance child routes in MarketingLayout via Outlet.
 * Same pattern as /superadmin/_layout.tsx — child components render their own
 * content inside the shared marketing chrome.
 *
 * Note: ComingSoonShell already wraps MarketingLayout, so child routes that use
 * ComingSoonShell will receive nested MarketingLayout. To avoid double-wrapping,
 * this layout passes through via Outlet only — each child provides its own shell.
 */

import { createFileRoute, Navigate, Outlet, useLocation } from '@tanstack/react-router';

export const Route = createFileRoute('/compliance')({
  component: ComplianceRoot,
});

function ComplianceRoot() {
  const pathname = useLocation({ select: (l) => l.pathname });
  // Bare /compliance is only a layout wrapper (no index) — a manual URL to it
  // would render a blank shell (found by the 2026-07-01 render sweep). Send it to
  // the primary compliance page instead.
  if (pathname === '/compliance' || pathname === '/compliance/') {
    return <Navigate to="/compliance/popia" />;
  }
  return <Outlet />;
}
